"use strict";

module.exports = function () {
    return {
        restrict: "AE",
        replace: true,
        scope: {
            residentId: "="
        },
        controller: "residentFinanceFunding.controller",
        controllerAs: "vm",
        templateUrl: "app/residents/directives/partials/residentFinanceFunding.html"
    };
}
